import React from 'react'
import {Helmet} from "react-helmet"
import { connect } from 'react-redux'
import { fetchNodeIfNeeded } from '~/nodes/actions'
import NotFound from '~/app/components/NotFound'

class Node extends React.Component {
  constructor() {
    super()
    this.state = {
      data: []
    }
    this.linkOut = this.linkOut.bind(this);
    /*window.onbeforeunload = function(e) {
      console.log( 'Dialog text here.' )
      return false;
    };*/

    this.Anchors = []

  }

  static fetchData(store, route, match) {
    let id = match.url.replace(/^\/+/g, '');
    return store.dispatch(fetchNodeIfNeeded(id))
  }

  componentDidMount() {
    document.getElementsByTagName('body')[0].className = 'node';
  }

  componentWillMount() {
    const { match, dispatch } = this.props
    let id = match.url.replace(/^\/+/g, '');
    dispatch(fetchNodeIfNeeded(id))
  }


  componentWillUnmount() {
    document.getElementsByTagName('body')[0].className = '';
  }

  componentDidUpdate() {
    const {match, nodes} = this.props
    //const {data} = this.state
    const data = nodes[match.path]
    if(data && data.body) {
      this.Anchors = document.getElementById('node').getElementsByTagName("a");
      //console.log(this.Anchors)

      for (var i = 0; i < this.Anchors.length ; i++) {
          this.Anchors[i].addEventListener("click",
              this.linkOut,
              false)
      }
    }
  }

  linkOut(event){
    event.preventDefault()
    //debugger
    if(event.currentTarget.getAttribute('href').match('^https?//.*')){
      window.open(event.currentTarget.getAttribute('href'), '_blank')
    } else {
      this.props.history.push(event.currentTarget.getAttribute('href'))
    }

  }

  render() {
    const {match, nodes} = this.props
    let id = match.url.replace(/^\/+/g, '');
    const data = nodes[id]
    let nodeClass = 'node-content '+ id

    if (data && data.error) {
      return ( <NotFound />)
    }
    else {

      //const {data} = this.state
      if(data && data.body) {
        return (
          <div id="node" className={nodeClass}>
            <div className="inside">
                <h1>{data.title[0].value}</h1>
                <div dangerouslySetInnerHTML={{ __html: data.body[0].value }} />
            </div>
            <Helmet>
              <title>{data.title[0].value}</title>
              <meta name="description" content="4ZZZ Community Radio" />
            </Helmet>
          </div>
        )
      }
      else {
        return null
      }
    }


  }
}

export default connect( state => { return { nodes: state.nodes }}) (Node)
